import { render, staticRenderFns } from "./pc-ad.vue?vue&type=template&id=2f5eb89c"
import script from "./pc-ad.vue?vue&type=script&lang=js"
export * from "./pc-ad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f5eb89c')) {
      api.createRecord('2f5eb89c', component.options)
    } else {
      api.reload('2f5eb89c', component.options)
    }
    module.hot.accept("./pc-ad.vue?vue&type=template&id=2f5eb89c", function () {
      api.rerender('2f5eb89c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/ad-management/pc-ad.vue"
export default component.exports